module.exports = __webpack_public_path__ + "static/img/superiority_pic3.4c0a77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/superiority_pic3.png
// module id = 483r
// module chunks = 1